import { User } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from 'users/queries/shared/keys'

type Variables = {
  users: User[]
}

export function useUpdateReminderDate() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: updateReminderDate,
    onSuccess: () => {
      return client.invalidateQueries({ queryKey: keys.all })
    },
  })

  function updateReminderDate({ users }: Variables): Promise<void> {
    return server.post(
      `/v2/users/reminder_dates`,
      users.map(user => parseInt(user.id))
    )
  }
}
